"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ark = require("@dateam/ark");
var _arkReact = require("@dateam/ark-react");
var _dropdownMenu = _interopRequireDefault(require("../dropdownMenu"));
var _components = require("./components");
var _FormContext = _interopRequireDefault(require("./FormContext"));
const Multiselect = _ref => {
  let {
    id,
    selected,
    className,
    children,
    state,
    readOnly,
    required,
    onChange,
    onFocus,
    onBlur
  } = _ref;
  const {
    controlId,
    isFocus,
    required: inputIsRequired,
    // TODO: Handle required in association with state prop
    onBlur: onInputBlur,
    onFocus: onInputFocus,
    onRequiredChange,
    setState
  } = _react.default.useContext(_FormContext.default);
  const inputRef = _react.default.useRef(null);
  const [openMenu, setOpenMenu] = _react.default.useState(false);
  const internalValueOptions = _react.default.useMemo(() => ({
    locked: isFocus
  }), [isFocus, onChange]);
  const [internalSelectedOption, setInternalSelectedOption] = (0, _arkReact.useInternalValueManager)(selected, internalValueOptions);
  _react.default.useEffect(() => setState?.(state), [state]);
  _react.default.useEffect(() => onRequiredChange?.(required ?? false), [required, onRequiredChange]);
  const onItemSelectionChange = _react.default.useCallback((itemValue, itemChecked) => {
    const newValue = Array.isArray(internalSelectedOption) ? [...internalSelectedOption] : [];
    const valueIdx = newValue.indexOf(itemValue);
    if (itemChecked === true && valueIdx === -1) {
      newValue.push(itemValue);
    } else if (itemChecked === false && valueIdx >= 0) {
      newValue.splice(valueIdx, 1);
    }
    setInternalSelectedOption(newValue);
    if ((0, _ark.isFunction)(onChange)) onChange(newValue);
  }, [onChange, internalSelectedOption, setInternalSelectedOption]);
  const childrenOptions = _react.default.useMemo(() => (0, _arkReact.childrenToReactElement)(children).filter(elementItem => elementItem.type.displayName === 'FormSelectOption').map(elementItem => {
    return elementItem.props;
  }), [children]);
  const selectOptions = _react.default.useMemo(() => childrenOptions.map((childrenItem, idx) => {
    const {
      value,
      children: itemChildren
    } = childrenItem;
    const checked = Array.isArray(internalSelectedOption) && internalSelectedOption.indexOf(value) >= 0;
    return /*#__PURE__*/_react.default.createElement(_components.MultiselectOption, {
      id: id,
      key: idx,
      value: value,
      checked: checked,
      onChange: onItemSelectionChange
    }, itemChildren);
  }), [id, childrenOptions, internalSelectedOption, onItemSelectionChange]);
  const selectedTextValues = _react.default.useMemo(() => {
    if (!Array.isArray(internalSelectedOption) || internalSelectedOption.length === 0 || internalSelectedOption.length === childrenOptions.length) {
      return 'Tous';
    }
    const values = internalSelectedOption.map(selectedValueEntry => {
      const childrenOption = childrenOptions.find(childrenEntry => childrenEntry.value === selectedValueEntry);
      if (childrenOption === undefined) return '';
      if ((0, _ark.isDefined)(childrenOption.selectedText)) return childrenOption.selectedText.toString();
      if ((0, _ark.isDefined)(childrenOption.value)) return childrenOption.value.toString();
      return '';
    });
    values.sort((itemA, itemB) => itemA.localeCompare(itemB));
    return values.join(', ');
  }, [internalSelectedOption, childrenOptions]);
  const handleInputBlur = _react.default.useCallback(event => {
    onInputBlur?.();
    onBlur?.(internalSelectedOption ?? [], event);
  }, [onInputBlur, onBlur, internalSelectedOption]);
  const handleInputFocus = _react.default.useCallback(() => {
    onInputFocus?.();
    onFocus?.();
  }, [onInputFocus, onFocus]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "formSelect"
  }, /*#__PURE__*/_react.default.createElement("input", {
    id: controlId,
    ref: inputRef,
    type: "text",
    className: (0, _arkReact.concatClassName)('formControl', readOnly ? 'formControl-readOnly' : null, className),
    value: selectedTextValues,
    readOnly: true,
    onClick: () => setOpenMenu(true),
    onBlur: handleInputBlur,
    onFocus: handleInputFocus
  }), /*#__PURE__*/_react.default.createElement(_dropdownMenu.default, {
    open: openMenu,
    anchorEl: inputRef,
    onClose: () => setOpenMenu(false)
  }, selectOptions));
};
process.env.NODE_ENV !== "production" ? Multiselect.propTypes = {
  id: _propTypes.default.string,
  selected: _propTypes.default.arrayOf(_propTypes.default.any),
  className: _propTypes.default.string,
  children: _propTypes.default.node,
  onChange: _propTypes.default.func
} : void 0;
Multiselect.defaultProps = {
  id: undefined,
  selected: [],
  className: undefined,
  children: undefined,
  onChange: undefined
};
var _default = exports.default = Multiselect;